var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuickSave = function SvgQuickSave(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6295_97682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 6H7.33333C6.59333 6 6 6.6 6 7.33333V16.6667C6 17.4 6.59333 18 7.33333 18H16.6667C17.4 18 18 17.4 18 16.6667V8.66667L15.3333 6ZM12 16.6667C10.8933 16.6667 10 15.7733 10 14.6667C10 13.56 10.8933 12.6667 12 12.6667C13.1067 12.6667 14 13.56 14 14.6667C14 15.7733 13.1067 16.6667 12 16.6667ZM14 10H7.33333V7.33333H14V10Z",
    fill: "#499CE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C15.3137 0 18.3138 1.34308 20.4854 3.51465L19.0713 4.92871C17.2616 3.11907 14.7614 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12H24C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0Z",
    fill: "#499CE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6.5H21.5V2L17 6.5Z",
    fill: "#499CE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6295_97682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuickSave);
export { ForwardRef as ReactComponent };